module.exports = __webpack_public_path__ + "static/img/part2.e068160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/part2.png
// module id = ZP9m
// module chunks = 96